import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import CandidatesTab from '../components/admin/CandidatesTab';
import RequestsTab from '../components/admin/RequestsTab';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('candidates');

  return (
    <div className="min-h-screen bg-[#0B0F1A] text-slate-200">
      <header className="sticky top-0 z-50 bg-[#0E1525] border-b border-slate-800 h-16 flex items-center px-6">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="https://customer-assets.emergentagent.com/job_submission-hub-21/artifacts/1pp9pqr0_1000260687.png"
              alt="BuildDirect Logo"
              className="h-10"
            />
            <span className="text-xs uppercase tracking-widest text-slate-400 font-semibold hidden sm:inline">Admin</span>
          </div>
          <button
            onClick={() => navigate('/admin-secure-bd2026/settings')}
            data-testid="admin-settings-button"
            className="text-slate-400 hover:text-slate-300 transition-colors"
            title="Settings"
          >
            <Settings className="h-5 w-5" />
          </button>
        </div>
      </header>

      <div className="p-6 max-w-[1400px] mx-auto">
        {/* Tabs */}
        <div className="flex gap-1 mb-6 bg-[#0E1525] border border-slate-800 p-1 rounded-lg w-fit">
          <button onClick={() => setActiveTab('candidates')} data-testid="tab-candidates"
            className={`px-4 py-2 text-xs uppercase tracking-wider font-semibold rounded transition-colors ${activeTab === 'candidates' ? 'bg-[#0B0F1A] text-slate-100 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}>
            Candidates
          </button>
          <button onClick={() => setActiveTab('requests')} data-testid="tab-requests"
            className={`px-4 py-2 text-xs uppercase tracking-wider font-semibold rounded transition-colors ${activeTab === 'requests' ? 'bg-[#0B0F1A] text-slate-100 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}>
            Requests
          </button>
        </div>

        {activeTab === 'candidates' && <CandidatesTab />}
        {activeTab === 'requests' && <RequestsTab />}
      </div>
    </div>
  );
};

export default AdminDashboard;
